"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiImageSize = exports.StylesList = exports.AiImageStyles = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const AiImageStyles_style_1 = require("./AiImageStyles.style");
const AiImageStyles_style_2 = require("./AiImageStyles.style");
function AiImageStyles({ title, styles, selectedStyle, onStyleChange, setStylesOpened, }) {
    const handleStyleClick = (event, style) => {
        event.preventDefault();
        event.stopPropagation();
        onStyleChange(style.value);
        setStylesOpened(false);
    };
    return ((0, jsx_runtime_1.jsxs)(AiImageStyles_style_2.StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyledTitleWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', children: title }) }), (0, jsx_runtime_1.jsx)(StylesList, { onClick: handleStyleClick, selected: selectedStyle, styles: styles })] }));
}
exports.AiImageStyles = AiImageStyles;
// WIP - We're gonna use it in the future
//export function StylesModal({
//   opened = false,
//   selected,
//   maxStyles,
//   styles,
//   onClose,
//   onClick,
// }: {
//   opened: boolean;
//   selected: string;
//   maxStyles: number;
//   styles: AiImageStylesProps['styles'];
//   onClick: (
//     event: React.MouseEvent<HTMLAnchorElement>,
//     style: AiImageStylesProps['styles'][0]
//   ) => void;
//   onClose: () => void;
// }) {
//   const stylesToShow = useMemo(() => {
//     const target = styles.slice(0, maxStyles);
//     const isSelectedStyleInStyles = target.some(
//       (style) => style.value === selected
//     );
//     const selectedStyle = styles.find((style) => style.value === selected);
//     if (isSelectedStyleInStyles || !selectedStyle) return target;
//     /**
//      * If the selected style is not in the styles list, we need to add it to the list
//      * and swap the second style with the selected one.
//      */
//     return target
//       .slice(0, 1)
//       .concat(selectedStyle)
//       .concat(target.slice(2, maxStyles));
//   }, [opened, styles, maxStyles]);
//   return (
//     <StyledStylesWrapper>
//       <StylesList selected={selected} styles={stylesToShow} onClick={onClick} />
//       <StyledContentModal opened={opened}>
//         <AppShell visible={true}>
//           <HeadingSection
//             icon={{
//               name: 'arrow-upload',
//               angle: 270,
//               position: 'left',
//             }}
//             onClick={onClose}
//           >
//             Styles
//           </HeadingSection>
//           <StylesList selected={selected} styles={styles} onClick={onClick} />
//         </AppShell>
//       </StyledContentModal>
//     </StyledStylesWrapper>
//   );
// }
function StylesList({ selected, styles, onClick, }) {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyledContent, { children: styles.map((style) => ((0, jsx_runtime_1.jsxs)(AiImageStyles_style_2.StyleItem, { selected: style.value === selected, onClick: (event) => onClick(event, style), children: [(0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyleImageWrapper, { type: "size", style: style.imageUrl
                        ? { backgroundImage: `url(${style.imageUrl})` }
                        : {}, children: !style.imageUrl && (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "magic-wand", size: "Medium" }) }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Small', children: style.name })] }, `image-style-${style.value}`))) }));
}
exports.StylesList = StylesList;
function AiImageSize({ title, items = [], selectedSize, onClick, }) {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(AiImageStyles_style_1.StyledImageSize, { children: [(0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyledTitleWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', children: title }) }), (0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyledContent, { children: items.map((item) => {
                    return ((0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyleItem, { selected: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.value) === item.value, onClick: () => onClick(item), children: (0, jsx_runtime_1.jsx)(AiImageStyles_style_2.StyleImageWrapper, { children: (0, jsx_runtime_1.jsxs)(AiImageStyles_style_1.StyledImageSizeItem, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: item.icon, size: 'Medium' }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", color: theme.Color.Neutrals.Gray, children: item.label })] }) }) }, `image-size-${item.value}`));
                }) })] }));
}
exports.AiImageSize = AiImageSize;
//# sourceMappingURL=AiImageStyles.js.map